import { Controller } from 'stimulus';

// Hydrates the header's login/profile-menu slot client-side. Pages that are cached
// at the edge (see EdgeCacheable, app/controllers/concerns/edge_cacheable.rb) always
// server-render the generic "Login" link, since the cached HTML is shared across every
// visitor regardless of their real session. This controller fetches the real per-visitor
// state from an uncached endpoint and swaps it in after load.
export default class extends Controller {
  connect() {
    fetch('/header-state', {
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': this.getMetaValue('csrf-token'),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.signed_in) {
          this.element.innerHTML = data.header_html;
        }
      });
  }

  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`);
    return element ? element.getAttribute('content') : null;
  }
}
